module.exports = __webpack_public_path__ + "07_long_yellow.148a3f11.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/07_long_yellow.png
// module id = qSGV
// module chunks = 0